import React, { createContext, useContext, useEffect, useState, useCallback, useRef } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const seq = useRef(0);

  const refreshUser = useCallback(async () => {
    const mine = ++seq.current;
    try { const { data } = await api.get("/auth/me"); if (mine === seq.current) setUser(data); return data; }
    catch (e) { if (mine === seq.current) setUser(null); return null; }
  }, []);

  const checkAuth = useCallback(async () => {
    setLoading(true);
    await refreshUser();
    setLoading(false);
  }, [refreshUser]);

  useEffect(() => {
    // If returning from Google OAuth callback, let AuthCallback handle it first.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    checkAuth();
  }, [checkAuth]);

  const storeSession = (data) => {
    if (data.session_token) localStorage.setItem("db_token", data.session_token);
    seq.current++;
    setUser(data.user);
    return data;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return storeSession(data);
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    return storeSession(data);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("db_token"); seq.current++; setUser(null);
  };
  const setRole = async (role) => {
    const { data } = await api.patch("/auth/role", { role });
    setUser(data.user); return data.user;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, setRole, refreshUser, storeSession }}>
      {children}
    </AuthContext.Provider>
  );
}
